var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa-sort ml-1 text-gray-400 fad",class:_vm.orderby === _vm.col ? 'text-teal-600 ' + (_vm.sortorder === 'asc' ? 'fa-sort-down' : 'fa-sort-up') : ''})}
var staticRenderFns = []

export { render, staticRenderFns }